<div class="legal-page">
  <!-- ════════════════ HERO BANNER ════════════════ -->
  <header class="legal-hero">
    <div class="legal-hero-inner">
      <!-- Breadcrumb -->
      <nav class="legal-hero-breadcrumb">
        <a routerLink="/">Início</a>
        <i class="fas fa-chevron-right"></i>
        <span>Termos e Condições</span>
      </nav>

      <!-- Eyebrow -->
      <div class="legal-hero-eyebrow">
        <i class="fas fa-shield-halved"></i>
        <span>Enquadramento Legal & Transparência</span>
      </div>

      <!-- Title & Subtitle -->
      <h1 class="legal-hero-title">
        Termos e Condições de <em>Adesão</em>
      </h1>

      <p class="legal-hero-desc">
        Regulamento geral de utilização da plataforma FundCube, direitos e deveres dos Promotores e Apoiantes,
        sistemas de liquidação financeira e protecção de dados pessoais em Angola.
      </p>

      <!-- Quick Metadata Pills -->
      <div class="legal-hero-meta">
        <span class="meta-pill">
          <i class="fas fa-calendar-check"></i> Actualizado em: <strong>{{ dataActualizacao }}</strong>
        </span>
        <span class="meta-pill">
          <i class="fas fa-id-card"></i> NIF: <strong>5001399934</strong>
        </span>
        <span class="meta-pill">
          <i class="fas fa-location-dot"></i> Jurisdição: <strong>República de Angola</strong>
        </span>
        <span class="meta-pill">
          <i class="fas fa-scale-balanced"></i> Lei n.º <strong>22/11</strong>
        </span>
      </div>

      <!-- Actions Bar -->
      <div class="legal-hero-actions">
        <button type="button" class="btn-action-hero" (click)="printDocument()">
          <i class="fas fa-print"></i> Imprimir Termos
        </button>
        <button type="button" class="btn-action-hero" (click)="copyLink()">
          <i class="fas fa-link"></i> Partilhar Ligação
        </button>
      </div>
    </div>

    <!-- Onda decorativa de transição inferior -->
    <div class="legal-hero-wave">
      <svg viewBox="0 0 1440 60" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="none">
        <path d="M0,40 C360,80 1080,0 1440,40 L1440,60 L0,60 Z" fill="#f8fafb" />
      </svg>
    </div>
  </header>

  <!-- ════════════════ CORPO PRINCIPAL ════════════════ -->
  <main class="container legal-main-container">
    <div class="legal-layout-grid">
      <!-- ── SIDEBAR / SUMÁRIO STICKY ── -->
      <aside class="legal-sidebar">
        <div class="legal-toc-card">
          <div class="toc-header">
            <i class="fas fa-list-ol"></i>
            <span>Índice do Documento</span>
          </div>

          <nav class="toc-nav">
            <button type="button" *ngFor="let sec of sections" class="toc-item"
              [class.active]="activeSectionId === sec.id" (click)="scrollTo(sec.id)">
              <span class="toc-num">{{ sec.number }}</span>
              <span class="toc-text">{{ sec.title }}</span>
            </button>
          </nav>

          <div class="toc-contact-card">
            <div class="tcc-icon"><i class="fas fa-envelope-open-text"></i></div>
            <div class="tcc-title">Dúvidas Jurídicas?</div>
            <p class="tcc-desc">A nossa equipa de conformidade está disponível para esclarecimentos.</p>
            <a href="mailto:geral@fundcube.ao" class="tcc-link">
              <i class="fas fa-paper-plane"></i> geral@fundcube.ao
            </a>
          </div>
        </div>
      </aside>

      <!-- ── CONTEÚDO LEGAL COMPLETO ── -->
      <article class="legal-content-body">

        <!-- RESUMO INFORMATIVO INICIAL -->
        <div class="legal-callout-card">
          <div class="lcc-icon"><i class="fas fa-circle-info"></i></div>
          <div class="lcc-body">
            <h4>Nota Prévia aos Utilizadores</h4>
            <p>
              Ao aceder, registar-se ou utilizar o website <strong>fundcube.ao</strong>, o utilizador declara
              expressamente que leu, compreendeu e concorda integralmente com as disposições legais e regulamentares
              aqui estipuladas. Caso não concorde com algum dos termos, deve cessar de imediato a utilização da
              plataforma.
            </p>
          </div>
        </div>

        <!-- ════ 1. INFORMAÇÕES DA EMPRESA ════ -->
        <section id="seccao-1" class="legal-section-block">
          <header class="section-block-header">
            <div class="sbh-badge"><i class="fa-solid fa-building"></i> Secção 01</div>
            <h2 class="section-block-title">1. Informações da Empresa</h2>
          </header>

          <div class="section-block-body">
            <p>
              A <strong>FundCube</strong> é uma plataforma de financiamento colectivo (<em>crowdfunding</em>), 100%
              angolana, cujo escopo social prende-se na prática de projectos criativos, de diversas categorias, tais
              como: Arte, Design, Banda desenhada, Artesanato, Teatro, Cinema, Vídeo, Tecnologia, Jogos, Dança, Música,
              Moda, Editoração, Jornalismo, Caridade, Comida e muitos mais, com base no princípio da confiança e da
              comunicação.
            </p>
            <p>
              Através da plataforma, conectamos pessoas com ideias inovadoras e projectos de impacto social a uma
              comunidade vibrante de apoiantes/investidores dispostos a fazer a diferença. A FundCube acredita no poder
              da colaboração para transformar sonhos em realidade.
            </p>

            <!-- A Nossa Missão -->
            <div class="highlight-subbox">
              <h3 class="subbox-title"><i class="fas fa-bullseye"></i> A Nossa Missão</h3>
              <p>A FundCube tem como principais missões:</p>
              <div class="mission-cards-grid">
                <div class="mission-card">
                  <span class="mc-letter">A</span>
                  <p><strong>Democratizar o acesso ao capital</strong> em Angola, permitindo que os empreendedores,
                    artistas, ONGs e outros idealizadores realizem seus sonhos.</p>
                </div>
                <div class="mission-card">
                  <span class="mc-letter">B</span>
                  <p><strong>Impulsionar projectos de impacto social</strong> em diversos sectores: (i) tecnologia, (ii)
                    educação, (iii) saúde, (iv) agricultura, (v) cultura e muito mais.</p>
                </div>
                <div class="mission-card">
                  <span class="mc-letter">C</span>
                  <p><strong>Fortalecer o ecossistema</strong> de colaboração e empreendedorismo em Angola, criando um
                    ambiente propício para o crescimento de ideias sustentáveis.</p>
                </div>
              </div>
            </div>

            <!-- Os Nossos Valores -->
            <div class="highlight-subbox">
              <h3 class="subbox-title"><i class="fas fa-gem"></i> Os Nossos Valores</h3>
              <div class="values-grid">
                <div class="value-item">
                  <div class="vi-icon"><i class="fas fa-eye"></i></div>
                  <div>
                    <strong>Transparência</strong>
                    <p>Apresentação clara e detalhada de objectivos, orçamentos e prazos, permitindo aos apoiantes o
                      acompanhamento em tempo real.</p>
                  </div>
                </div>
                <div class="value-item">
                  <div class="vi-icon"><i class="fas fa-shield-heart"></i></div>
                  <div>
                    <strong>Responsabilidade</strong>
                    <p>Conexão com projectos de impacto positivo e aplicação de critérios rigorosos de conformidade e
                      validação.</p>
                  </div>
                </div>
                <div class="value-item">
                  <div class="vi-icon"><i class="fas fa-lightbulb"></i></div>
                  <div>
                    <strong>Inovação</strong>
                    <p>Melhoria contínua da experiência dos utilizadores e difusão das melhores práticas globais de
                      financiamento colaborativo.</p>
                  </div>
                </div>
                <div class="value-item">
                  <div class="vi-icon"><i class="fas fa-leaf"></i></div>
                  <div>
                    <strong>Sustentabilidade</strong>
                    <p>Apoio prioritário a iniciativas que protejam o meio ambiente e fomentem a inclusão socioeconómica
                      nacional.</p>
                  </div>
                </div>
              </div>
            </div>

            <!-- Ofertas aos Nossos Utilizadores -->
            <div class="highlight-subbox">
              <h3 class="subbox-title"><i class="fas fa-gift"></i> Ofertas aos Nossos Utilizadores</h3>
              <ul class="styled-legal-list">
                <li><strong>Suporte personalizado:</strong> Acompanhamento permanente na criação, divulgação e gestão
                  operacional das campanhas.</li>
                <li><strong>Recursos valiosos:</strong> Dicas de marketing, ferramentas de comunicação e manuais de boas
                  práticas para acelerar o sucesso do projecto.</li>
                <li><strong>Networking qualificado:</strong> Conexão dinâmica entre Promotores de campanha, investidores
                  e especialistas em impacto social.</li>
                <li><strong>Inspiração contínua:</strong> Acesso a um portfólio de campanhas transformadoras que servem
                  de modelo inspirador.</li>
              </ul>
            </div>

            <!-- Regras da FundCube -->
            <div class="highlight-subbox alert-style">
              <h3 class="subbox-title"><i class="fas fa-triangle-exclamation"></i> Regras da FundCube</h3>
              <p class="mb-3 text-sm">
                As regras abaixo fundamentam a perspectiva ética da FundCube. As decisões finais sobre a admissibilidade
                de projectos baseiam-se nos seguintes critérios:
              </p>
              <ol class="legal-alpha-list">
                <li>Os projectos integrados na FundCube devem servir para serem compartilhados com outras pessoas.</li>
                <li>Os projectos e estatísticas apresentadas de doadores devem obedecer aos princípios da honestidade e
                  da clareza.</li>
                <li>Os projectos a serem integrados na FundCube não podem enganar as pessoas ou deturpar factos. Os seus
                  criadores devem ser sinceros em relação ao que planeiam realizar e como planeiam fazê-lo.</li>
                <li>Quando os projectos envolverem a fabricação e distribuição de itens complexos (como gadgets
                  físicos), a FundCube exige a apresentação de um protótipo aos patrocinadores.</li>
                <li>A demonstração do protótipo deve refletir o estado actual do produto, não devendo incluir photoshop
                  ou efeitos especiais para simular funcionalidades inexistentes.</li>
                <li>Se um projecto requer integração de software e hardware, os criadores são obrigados a demonstrar a
                  funcionalidade claramente ou explicitar que a mesma ainda não foi desenvolvida.</li>
                <li>É proibida a utilização de imagens enganosas (renderizações fotorrealistas ou vídeos altamente
                  manipulados que transmitam uma impressão falsa do estágio de desenvolvimento).</li>
                <li>Os criadores não podem deturpar ou inflacionar artificialmente o número de investidores ou os
                  valores investidos na campanha.</li>
              </ol>
            </div>

            <!-- Como Funciona a FundCube -->
            <div class="highlight-subbox step-flow-box">
              <h3 class="subbox-title"><i class="fas fa-arrows-split-up-and-left"></i> Como Funciona a FundCube?</h3>
              <div class="how-it-works-steps">
                <div class="hiw-step">
                  <div class="step-num-pill">1</div>
                  <div class="step-content">
                    <h5>Crie a sua campanha</h5>
                    <p>Registe-se em <strong>fundcube.ao</strong>, preencha o formulário detalhando a sua ideia,
                      objectivos, metas de arrecadação e duração.</p>
                  </div>
                </div>
                <div class="hiw-step">
                  <div class="step-num-pill">2</div>
                  <div class="step-content">
                    <h5>Divulgue a sua campanha</h5>
                    <p>Partilhe nas redes sociais, com círculos de confiança, familiares e junto da comunidade em geral
                      para angariar engajamento.</p>
                  </div>
                </div>
                <div class="hiw-step">
                  <div class="step-num-pill">3</div>
                  <div class="step-content">
                    <h5>Receba Apoio dos Investidores</h5>
                    <p>Investimentos aceites a nível nacional via Multicaixa Express, Referência Bancária ou
                      Transferência, com verificação de conformidade.</p>
                  </div>
                </div>
                <div class="hiw-step">
                  <div class="step-num-pill">4</div>
                  <div class="step-content">
                    <h5>Realize o seu projecto</h5>
                    <p>Ao atingir a meta estabelecida dentro das normas, os fundos são liquidados para que execute o seu
                      projecto com sucesso.</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        <!-- ════ 2. OBJECTO E ÂMBITO ════ -->
        <section id="seccao-2" class="legal-section-block">
          <header class="section-block-header">
            <div class="sbh-badge"><i class="fa-solid fa-file-contract"></i> Secção 02</div>
            <h2 class="section-block-title">2. Objecto e Âmbito</h2>
          </header>

          <div class="section-block-body">
            <ol class="legal-numbered-list">
              <li>Os presentes Termos e Condições estabelecem as regras de acesso e utilização do site de internet da
                FundCube (<strong>fundcube.ao</strong> ou “Website”), pelo que a sua utilização pressupõe total
                aceitação e cumprimento.</li>
              <li>A <strong>FUNDCUBE – PROMOÇÃO DE INVESTIMENTOS, LIMITADA</strong>, titular do NIF
                <strong>5001399934</strong>, é proprietária exclusiva do Website.</li>
              <li>O Website tem como objectivo intermediar as relações entre os utilizadores registados que pretendem
                promover os seus projectos (“Promotores”) e os utilizadores registados que desejam apoiar os Promotores
                nos seus projectos, mediante um investimento (“Investidores”).</li>
              <li>O conteúdo dos Promotores e os sites electrónicos eventualmente relacionados com o Website (através de
                hiperligações “Links”) estão licenciados, pertencem e são disponibilizados sob gestão da FundCube.</li>
              <li>
                Os utilizadores (Promotores e Investidores), ao utilizarem o Website, fazem-no por sua conta e risco, e
                obrigam-se expressamente a:
                <div class="sub-clause-box">
                  <p><strong>I.</strong> Respeitar integralmente os direitos de autor e de propriedade intelectual da
                    FundCube e dos Promotores;</p>
                  <p><strong>II.</strong> Usar de modo correcto e adequado o Website e os seus conteúdos, de acordo com
                    as condições que declara expressamente ter lido, compreendido e aceitado na íntegra;</p>
                  <p><strong>III.</strong> Não modificar ou descompilar o software do Website com o objectivo de obter
                    acesso não autorizado a quaisquer dos seus conteúdos.</p>
                </div>
              </li>
              <li>Os utilizadores do Website, ao acederem a sites electrónicos de terceiros através de hiperligações
                disponibilizadas, fazem-no por sua conta e risco, não podendo imputar qualquer responsabilidade à
                FundCube no que respeita a anomalias, vírus ou danos causados.</li>
              <li>Qualquer pessoa, desde que concorde com as condições da FundCube, pode aceder ao Website.</li>
              <li>O acesso à publicação de projectos e à arrecadação de fundos é permitido <strong>apenas a maiores de
                  18 anos de idade</strong>.</li>
            </ol>
          </div>
        </section>

        <!-- ════ 3. CONTEÚDOS PROIBIDOS ════ -->
        <section id="seccao-3" class="legal-section-block">
          <header class="section-block-header">
            <div class="sbh-badge danger"><i class="fa-solid fa-ban"></i> Secção 03</div>
            <h2 class="section-block-title">3. Conteúdos Proibidos</h2>
          </header>

          <div class="section-block-body">
            <ol class="legal-numbered-list">
              <li>A FundCube não disponibilizará no Website quaisquer projectos de conteúdo racista, discriminatório,
                violento ou que apresente linguagem ofensiva, obscena e difamatória.</li>
              <li>De igual modo, não serão admissíveis projectos que contenham conteúdos que infrinjam qualquer registo
                ou direito de propriedade industrial (e.g. patentes, marcas registadas), segredo industrial, ou qualquer
                outro tipo de registo de propriedade intelectual de terceiros.</li>
              <li>A FundCube reserva-se o direito de bloquear qualquer conteúdo ou eliminar qualquer projecto, sem aviso
                prévio e sem obrigação de indemnização, cujos conteúdos atentem contra direitos de propriedade
                intelectual de terceiros, ou cujos promotores prestem falsas declarações ou tentem induzir o público em
                erro com informações deliberadamente incorrectas.</li>
              <li>Se, não obstante a advertência constante dos pontos 3.1 e 3.2, os Promotores ou investidores
                submeterem conteúdos não admissíveis, estes responderão com exclusividade civil e penalmente, ficando a
                FundCube isenta de qualquer responsabilidade.</li>
            </ol>
          </div>
        </section>

        <!-- ════ 4. CONTEÚDOS DO WEBSITE ════ -->
        <section id="seccao-4" class="legal-section-block">
          <header class="section-block-header">
            <div class="sbh-badge"><i class="fa-solid fa-globe"></i> Secção 04</div>
            <h2 class="section-block-title">4. Conteúdos do Website</h2>
          </header>

          <div class="section-block-body">
            <ol class="legal-numbered-list">
              <li>Os utilizadores estão autorizados pela FundCube a aceder e utilizar os conteúdos do Website
                exclusivamente para fins pessoais e não comerciais.</li>
              <li>Os utilizadores estão autorizados a criar hiperligações (links) para o Website, desde que essas
                hiperligações abram em nova janela do navegador, indicando explicitamente a ligação ao portal da
                FundCube, de modo a evitar confusão com os seus próprios portais.</li>
              <li>A FundCube proíbe a reprodução, transferência, distribuição ou armazenamento de conteúdos sem
                autorização prévia e escrita desta e/ou dos Promotores envolvidos.</li>
              <li>Sem a devida autorização prévia e escrita, é estritamente proibida a modificação, cópia, distribuição,
                publicação, licenciamento ou criação de conteúdos derivados do Website.</li>
              <li>A FundCube poderá a qualquer momento alterar, suspender ou descontinuar quaisquer projectos divulgados
                que violem os Termos e Condições, sem obrigação de indemnização a terceiros, sem prejuízo do reembolso
                de garantias de investidores quando aplicável.</li>
            </ol>
          </div>
        </section>

        <!-- ════ 5. DIREITOS DE PROPRIEDADE INTELECTUAL ════ -->
        <section id="seccao-5" class="legal-section-block">
          <header class="section-block-header">
            <div class="sbh-badge"><i class="fa-solid fa-copyright"></i> Secção 05</div>
            <h2 class="section-block-title">5. Direitos de Propriedade Intelectual</h2>
          </header>

          <div class="section-block-body">
            <ol class="legal-numbered-list">
              <li>Todos os direitos de autor e direitos conexos relativos aos conteúdos, layout, ilustrações e código do
                Website pertencem ou encontram-se devidamente licenciados à FundCube.</li>
              <li>É estritamente proibida a reprodução ou representação, total ou parcial, de quaisquer denominações
                sociais, marcas comerciais ou sinais distintivos da FundCube protegidos nos termos da legislação de
                propriedade industrial.</li>
              <li>Qualquer reprodução de sinal distintivo carece impreterivelmente de autorização prévia, expressa e
                escrita da FundCube ou dos legítimos titulares.</li>
            </ol>
          </div>
        </section>

        <!-- ════ 6. REGISTO PRÉVIO DO UTILIZADOR ════ -->
        <section id="seccao-6" class="legal-section-block">
          <header class="section-block-header">
            <div class="sbh-badge"><i class="fa-solid fa-user-check"></i> Secção 06</div>
            <h2 class="section-block-title">6. Registo Prévio do Utilizador</h2>
          </header>

          <div class="section-block-body">
            <h4 class="font-bold text-gray-800 mb-2">6.1 Dados Pessoais</h4>
            <ol class="legal-numbered-list">
              <li>Os utilizadores que pretendam criar projectos ou apoiar financeiramente campanhas devem registar-se
                previamente no Website, introduzindo os seus dados de identificação (nome de utilizador, email,
                palavra-passe e demais elementos exigidos).</li>
              <li>O não preenchimento dos campos obrigatórios devidamente assinalados implica a invalidade e recusa do
                registo.</li>
              <li>A omissão ou inexatidão dos dados fornecidos são da única e exclusiva responsabilidade do utilizador
                declarante.</li>
              <li>O registo prévio e a utilização do Website obedecem rigorosamente à Política de Privacidade e
                Protecção de Dados Pessoais.</li>
              <li>A FundCube obriga-se a salvaguardar a privacidade online dos seus utilizadores nos termos da
                <strong>Lei n.º 22/11, de 17 de Junho</strong> (Lei da Protecção dos Dados Pessoais de Angola).</li>
            </ol>
          </div>
        </section>

        <!-- ════ 7. UTILIZAÇÃO DE IMAGENS E INFORMAÇÕES PROMOCIONAIS ════ -->
        <section id="seccao-7" class="legal-section-block">
          <header class="section-block-header">
            <div class="sbh-badge"><i class="fa-solid fa-photo-film"></i> Secção 07</div>
            <h2 class="section-block-title">7. Utilização de Imagens e Informações para Fins Promocionais</h2>
          </header>

          <div class="section-block-body">
            <p>
              A FundCube reserva-se o direito de utilizar livremente imagens, vídeos e informações públicas relacionadas
              às campanhas hospedadas em seu portal nas suas demais plataformas de comunicação (incluindo redes sociais,
              televisão e meios de imprensa), visando divulgar o ecossistema e inspirar novos criadores.
            </p>

            <div class="sub-clause-section">
              <h4 class="font-bold text-gray-800 mb-1">7.1 Consentimento do Promotor</h4>
              <p class="text-sm text-gray-600 mb-2">
                <strong>7.1.1.</strong> Ao submeter uma campanha na FundCube, o Promotor cede automaticamente o direito
                não exclusivo, irrevogável e gratuito de utilização dos materiais visuais e descritivos para fins
                promocionais institucionais.<br>
                <strong>7.1.2.</strong> A cessão referida abrange a reprodução, adaptação, distribuição e comunicação
                pública dos materiais, em qualquer suporte, sem exigência de pagamento ou autorização adicional.
              </p>
            </div>

            <div class="sub-clause-section">
              <h4 class="font-bold text-gray-800 mb-1">7.2 Limitações ao Uso</h4>
              <p class="text-sm text-gray-600 mb-2">
                <strong>7.2.1.</strong> A FundCube não utilizará imagens ou materiais das campanhas para fins comerciais
                desvinculados da divulgação das campanhas e da promoção da missão da plataforma.<br>
                <strong>7.2.2.</strong> A utilização dos materiais será sempre conduzida de forma ética e responsável,
                salvaguardando a imagem e a honra do Promotor e da causa.
              </p>
            </div>

            <div class="sub-clause-section">
              <h4 class="font-bold text-gray-800 mb-1">7.3 Direitos do Promotor</h4>
              <p class="text-sm text-gray-600">
                <strong>7.3.1.</strong> O Promotor pode solicitar a remoção de imagens ou vídeos da sua campanha
                mediante apresentação de justificativa plausível e fundamentada.<br>
                <strong>7.3.2.</strong> A FundCube compromete-se a analisar o pedido e aplicar as medidas cabíveis no
                prazo de <strong>30 dias</strong> após a recepção formal do requerimento.
              </p>
            </div>
          </div>
        </section>

        <!-- ════ 8. RESPONSABILIDADE – PROMOTORES E INVESTIDORES ════ -->
        <section id="seccao-8" class="legal-section-block">
          <header class="section-block-header">
            <div class="sbh-badge"><i class="fa-solid fa-handshake-angle"></i> Secção 08</div>
            <h2 class="section-block-title">8. Responsabilidade – Relação com os Promotores e Investidores</h2>
          </header>

          <div class="section-block-body">
            <ol class="legal-numbered-list">
              <li>A FundCube, enquanto gestora da plataforma tecnológica, actua em todas as circunstâncias unicamente
                como <strong>mera intermediária</strong> da relação entre Investidores e Promotores.</li>
              <li>A FundCube não garante o êxito ou a rentabilidade dos projectos, nem detém poderes de representação
                legal dos utilizadores.</li>
              <li>Não poderá ser imputada à FundCube qualquer responsabilidade por obrigações decorrentes do
                relacionamento entre Promotores e Investidores, designadamente eventuais incumprimentos ou prejuízos de
                execução.</li>
              <li>Os Promotores são integral e exclusivamente responsáveis pela boa execução dos projectos e pela
                entrega efectiva das contrapartidas e recompensas prometidas.</li>
              <li>Os Promotores não oferecem qualquer garantia formal de sucesso à FundCube relativamente ao desfecho
                dos projectos.</li>
            </ol>
          </div>
        </section>

        <!-- ════ 9. SISTEMAS DE PAGAMENTOS ════ -->
        <section id="seccao-9" class="legal-section-block">
          <header class="section-block-header">
            <div class="sbh-badge primary"><i class="fa-solid fa-credit-card"></i> Secção 09</div>
            <h2 class="section-block-title">9. Sistemas de Pagamentos</h2>
          </header>

          <div class="section-block-body">
            <ol class="legal-numbered-list">
              <li>Os investimentos são processados mediante sistemas de pagamento de entidades terceiras e parceiros
                bancários credenciados em Angola.</li>
              <li>A utilização dos meios de pagamento implica a aceitação dos termos de serviço das respectivas
                entidades financeiras intermediárias.</li>
              <li>A concessão de investimentos ou eventuais reembolsos sujeitam-se às taxas em vigor praticadas pelos
                parceiros de processamento financeiro.</li>
              <li>A FundCube não responde por anomalias ou indisponibilidades temporárias das redes bancárias ou
                plataformas de liquidação externas.</li>
              <li>Na qualidade de intermediária, a FundCube actua como <strong>fiel depositária</strong> dos montantes
                arrecadados durante o período de captação.</li>
              <li>Os fundos são creditados e registados nas contas dos investidores e vinculados às campanhas
                especificamente apoiadas.</li>
              <li>
                <div class="rule-highlight-box">
                  <i class="fas fa-check-double"></i>
                  <div>
                    <strong>Regra dos 35% de Sucesso:</strong> O sistema obedece ao modelo de financiamento colaborativo
                    onde o Promotor recebe os fundos angariados <em>apenas se a campanha atingir no mínimo 35% do valor
                      pretendido</em> dentro do prazo aprovado.
                  </div>
                </div>
              </li>
              <li>Os montantes em conta destinam-se exclusivamente à aplicação em campanhas da plataforma, sob ordem
                expressa do titular.</li>
              <li>A FundCube restituirá aos investidores os montantes não utilizados caso a campanha não alcance os
                requisitos mínimos de sucesso.</li>
              <li>A devolução prevista no ponto anterior será <strong>processada de forma automática</strong> no
                encerramento de campanhas sem sucesso.</li>
              <li>Saldos inactivos por período superior a 2 anos (sem movimentações) poderão ser alocados a projectos da
                mesma categoria inicialmente apoiada.</li>
              <li>Contas sem qualquer investimento anterior e inactivas por mais de 2 anos poderão ter saldos aplicados
                em projectos gerais da plataforma.</li>
              <li>A FundCube emitirá notificações periódicas aos utilizadores com saldo para que decidam sobre o seu
                reinvestimento ou levantamento atempado.</li>
            </ol>
          </div>
        </section>

        <!-- ════ 10. INVESTIDORES E PROMOTORES DE PROJECTOS ════ -->
        <section id="seccao-10" class="legal-section-block">
          <header class="section-block-header">
            <div class="sbh-badge primary"><i class="fa-solid fa-users-gear"></i> Secção 10</div>
            <h2 class="section-block-title">10. Investidores e Promotores de Projectos</h2>
          </header>

          <div class="section-block-body">
            <div class="financial-parameters-strip">
              <div class="fp-item">
                <span class="fp-label">Investimento Mínimo</span>
                <span class="fp-val">2.000,00 Kz</span>
              </div>
              <div class="fp-item">
                <span class="fp-label">Taxa de Transacção</span>
                <span class="fp-val">3,2%</span>
              </div>
              <div class="fp-item">
                <span class="fp-label">Comissão de Plataforma</span>
                <span class="fp-val">8% (+ IVA)</span>
              </div>
              <div class="fp-item">
                <span class="fp-label">Autofinanciamento Máximo</span>
                <span class="fp-val">20%</span>
              </div>
            </div>

            <ol class="legal-numbered-list">
              <li>Os investidores são livres para apoiar quaisquer projectos, em qualquer valor a partir de
                <strong>2.000 Kwanzas</strong>, sem imposição de montante máximo.</li>
              <li>Por cada operação efectuada, é cobrada uma comissão de transacção de <strong>3,2%</strong> associada
                aos custos bancários e de processamento.</li>
              <li>A proveniência e a responsabilidade da licitude dos valores investidos cabem exclusivamente ao
                investidor.</li>
              <li>Os Promotores de projectos podem investir na sua própria campanha, desde que esse valor não ultrapasse
                o limite de <strong>20% do financiamento solicitado</strong>.</li>
              <li>Apoios em nome de terceiros não registados podem ser introduzidos desde que com expressa identificação
                do investidor de origem.</li>
              <li>Projectos que atinjam a meta obrigam-se a manter os investidores regularmente informados e a entregar
                todas as recompensas devidas.</li>
              <li>O valor máximo de angariação de uma campanha está limitado a <strong>dez (10) vezes</strong> o
                montante global inicialmente orçamentado.</li>
              <li>Os Promotores comprometem-se à <strong>exclusividade da campanha</strong>, disponibilizando a oferta
                numa única plataforma durante o período acordado.</li>
              <li>Os Promotores pagarão à FundCube uma <strong>comissão de 8% (+ IVA)</strong> sobre o total angariado,
                aplicável desde que a campanha atinja pelo menos 35% da meta.</li>
            </ol>
          </div>
        </section>

        <!-- ════ 11. POLÍTICA DE PRIVACIDADE ════ -->
        <section id="seccao-11" class="legal-section-block">
          <header class="section-block-header">
            <div class="sbh-badge"><i class="fa-solid fa-user-shield"></i> Secção 11</div>
            <h2 class="section-block-title">11. Política de Privacidade</h2>
          </header>

          <div class="section-block-body">
            <p>
              A FundCube respeita integralmente a privacidade e a reserva da vida privada dos seus utilizadores,
              garantindo a observância estrita das disposições legais da República de Angola em matéria de protecção e
              confidencialidade de dados pessoais, nomeadamente o estabelecido na <strong>Lei n.º 22/11, de 17 de Junho
                (Lei da Protecção dos Dados Pessoais)</strong>.
            </p>
            <div class="highlight-subbox step-flow-box mt-3 mb-0">
              <div class="subbox-title">
                <i class="fas fa-file-shield text-emerald-600"></i> Documento Oficial de Privacidade
              </div>
              <p class="mb-2">
                Para consultar a versão integral e regulamentar da nossa política de tratamento de dados, prazos de conservação, direitos dos titulares e contactos do Encarregado de Dados (DPO), aceda à página dedicada:
              </p>
              <a routerLink="/politica-privacidade" class="btn btn-primary btn-sm btn-rounded inline-flex items-center gap-2">
                <i class="fas fa-arrow-up-right-from-square"></i> Aceder à Política de Privacidade Completa
              </a>
            </div>
          </div>
        </section>

        <!-- ════ 12. CONTA DE UTILIZADOR E PROTECÇÃO DE DADOS ════ -->
        <section id="seccao-12" class="legal-section-block">
          <header class="section-block-header">
            <div class="sbh-badge"><i class="fa-solid fa-id-card"></i> Secção 12</div>
            <h2 class="section-block-title">12. Conta de Utilizador e Gestão de Dados</h2>
          </header>

          <div class="section-block-body">
            <ol class="legal-numbered-list">
              <li>Os dados facultados na funcionalidade “Criar conta de utilizador” integram um ficheiro seguro gerido
                pela FundCube.</li>
              <li>Os tratamentos de dados pessoais observam as diretrizes da <strong>Comissão Nacional de Protecção de
                  Dados (CNPD)</strong>.</li>
              <li>Os dados recolhidos destinam-se à gestão das contas, processamento de apoios, atribuição de benefícios
                e cumprimento regulatório.</li>
              <li>Informações autorizadas poderão ser utilizadas na divulgação de campanhas, no âmbito da legislação
                aplicável.</li>
              <li>
                Ao registar-se, o utilizador reconhece e declara expressamente que:
                <div class="sub-clause-box">
                  <p><strong>a.</strong> Aceita esta política e autoriza o tratamento dos seus dados para a gestão das
                    campanhas apoiadas;</p>
                  <p><strong>b.</strong> Compreende os riscos intrínsecos de tráfego de dados na rede pública de
                    internet;</p>
                  <p><strong>c.</strong> Assume a responsabilidade pelas operações e credenciais de acesso por si
                    mantidas.</p>
                </div>
              </li>
              <li>O registo oferece opção de consentimento para recepção de comunicados e novidades das campanhas.</li>
              <li>O utilizador pode aceder, rectificar ou actualizar os seus dados a qualquer momento no seu painel ou
                via correio electrónico.</li>
              <li>A FundCube adopta medidas técnicas e organizativas rigorosas contra destruição acidental, acessos não
                autorizados e intrusões.</li>
              <li>A FundCube é a entidade formalmente responsável pelo tratamento de dados nos termos legais angolanos.
              </li>
              <li>
                <div class="rule-highlight-box alert">
                  <i class="fas fa-trash-can"></i>
                  <div>
                    <strong>Eliminação de Dados Pessoais:</strong> O titular pode solicitar a eliminação dos seus dados
                    enviando um e-mail para <a href="mailto:geral@fundcube.ao"
                      class="font-bold underline">geral@fundcube.ao</a>. O pedido será processado no prazo máximo de
                    <strong>quatro (4) dias úteis</strong>.
                  </div>
                </div>
              </li>
            </ol>
          </div>
        </section>

        <!-- ════ 13. COOKIES ════ -->
        <section id="seccao-13" class="legal-section-block">
          <header class="section-block-header">
            <div class="sbh-badge"><i class="fa-solid fa-cookie-bite"></i> Secção 13</div>
            <h2 class="section-block-title">13. Cookies e Dados de Navegação</h2>
          </header>

          <div class="section-block-body">
            <ol class="legal-numbered-list">
              <li>A FundCube recolhe informações anónimas de navegação (tipo de browser, sistema operacional, horários
                de acesso) com recurso a cookies de sessão e analítica.</li>
              <li>Esses dados contemplam contagens de visitas diárias, padrões de navegação e páginas mais acedidas para
                fins estatísticos.</li>
              <li>Os dados anónimos visam exclusivamente aprimorar a usabilidade e o desempenho da plataforma, sem
                identificar os dados civis do visitante sem consentimento.</li>
              <li>A política de cookies poderá ser actualizada em função de melhorias técnicas ou recomendações das
                autoridades de protecção de dados.</li>
            </ol>
          </div>
        </section>

        <!-- ════ 14. RESOLUÇÃO DE LITÍGIOS ════ -->
        <section id="seccao-14" class="legal-section-block">
          <header class="section-block-header">
            <div class="sbh-badge"><i class="fa-solid fa-scale-balanced"></i> Secção 14</div>
            <h2 class="section-block-title">14. Resolução de Litígios e Foro Competente</h2>
          </header>

          <div class="section-block-body">
            <ol class="legal-numbered-list">
              <li>
                <strong>Fase de Mediação Prévia:</strong> Para dirimir qualquer litígio resultante da interpretação ou
                execução dos presentes Termos, as partes comprometem-se a procurar de boa-fé uma solução amigável no
                prazo máximo de <strong>trinta (30) dias</strong>, através de mediação no <strong>Centro de Resolução
                  Extrajudicial de Litígios de Luanda (CRELL)</strong>.
              </li>
              <li>
                <strong>Litígios até 500.000,00 Kz:</strong> Não sendo alcançado acordo na mediação, para litígios de
                valor igual ou inferior a <strong>500.000,00 Kz (Quinhentos Mil Kwanzas)</strong>, é competente o
                <strong>Tribunal Provincial da Comarca de Luanda</strong>, com expressa renúncia a qualquer outro.
              </li>
              <li>
                <strong>Litígios superiores a 500.000,00 Kz:</strong> Para valores que ultrapassem o montante supra, as
                controvérsias serão decididas por <strong>Tribunal Arbitral</strong> em Luanda, na língua portuguesa,
                nos termos da Lei da Arbitragem Voluntária de Angola, por árbitro único consensual ou colégio de três
                árbitros.
              </li>
            </ol>
          </div>
        </section>

        <!-- ════ 15. DISPOSIÇÕES FINAIS ════ -->
        <section id="seccao-15" class="legal-section-block">
          <header class="section-block-header">
            <div class="sbh-badge"><i class="fa-solid fa-gavel"></i> Secção 15</div>
            <h2 class="section-block-title">15. Disposições Finais</h2>
          </header>

          <div class="section-block-body">
            <ol class="legal-numbered-list">
              <li>A eventual declaração de nulidade ou ineficácia de alguma cláusula do presente documento não
                comprometerá a validade e vigência das demais disposições.</li>
              <li>A todas as relações contratuais, obrigações e matérias reguladas por estes Termos e Condições é
                <strong>aplicável a Legislação da República de Angola</strong>.</li>
            </ol>
          </div>
        </section>

        <!-- CARD FINAL DE SUPORTE -->
        <div class="legal-footer-support-card">
          <div class="lfsc-icon"><i class="fas fa-hand-holding-heart"></i></div>
          <div class="lfsc-content">
            <h3>Construa o Futuro com a FundCube</h3>
            <p>Junte-se à maior comunidade angolana de criatividade, empreendedorismo e investimento colaborativo.</p>
            <div class="lfsc-buttons">
              <a routerLink="/criar-campanha" class="btn-primary-support">
                <i class="fas fa-plus-circle"></i> Criar uma Campanha
              </a>
              <a routerLink="/campanhas" class="btn-secondary-support">
                <i class="fas fa-magnifying-glass"></i> Explorar Campanhas
              </a>
            </div>
          </div>
        </div>

      </article>
    </div>
  </main>

  <!-- NEWSLETTER COMPONENT -->
  <app-newsletter></app-newsletter>
</div>